import { render, staticRenderFns } from "./AdminUtilityManageBankAccountBlacklist.vue?vue&type=template&id=2f2df090"
import script from "./AdminUtilityManageBankAccountBlacklist.vue?vue&type=script&lang=ts"
export * from "./AdminUtilityManageBankAccountBlacklist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports